<template>
<!-- <div class="new-order-wrapper"> -->
  <div class="grid-responsive" style="width: 100%;">
    <div class="grid">
      <div v-for="(item, i) in tableList" :key="item.id"
        class="grid-item"
        :style="{ 
          backgroundColor: (currentIndex === i && highlight) 
                            ? '#b4ded5' 
                            : $store.getters.printStaffColor(item) 
        }"
        @click="handleClickItem(item, i)">
        {{  item.name }}<br>
        <template v-if="type == 'staff'">{{ item.ref }}</template>
      </div>
      <div class="text-result" v-if="!tableList.length" v-translate>No results found!</div>
    </div>
  </div>
<!--   </div> -->
</template>

<script>

export default {
  name: 'GridView',
  props: {
    items: { type: Array, default: () => ([]) },
    highlight: { type: Boolean, default: false },
    type: { type: String, default: '' },
  },
  data() {
    return {
      currentIndex: null,
    };
  },
  computed: {
    tableList() { 
      return this.$store.state.auth.locations[this.user.location.id].locationTables;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    handleClickItem(item, index) {
      this.currentIndex = index;
      this.$emit('pickTable', item);
    }
  },
};
</script>
